module.exports = __webpack_public_path__ + "826e79fdfeeb38b38f508a22108b127f.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/hand/calculator.png
// module id = 1999
// module chunks = 0